

module.exports = __webpack_require__.stylable.create(
    "ProGalleryHoverItem2744258851",
    {"classes":{"root":"ProGalleryHoverItem2744258851__root","WarpContent":"ProGalleryHoverItem2744258851__WarpContent","WarpIconAndText":"ProGalleryHoverItem2744258851__WarpIconAndText","Text":"ProGalleryHoverItem2744258851__Text","caption":"ProGalleryHoverItem2744258851__caption"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size: '24px', lineHeight: '24px'}\"","HoverFont":"\"fallback(font(--galleryHoverFont), font({theme: 'Body-M', size: '24px', lineHeight: '24px'}))\""},"keyframes":{}},
    "",
    1,
    "ProGalleryHoverItem2744258851",
    null
);
